module.exports = __webpack_public_path__ + "img/wz-3-9.577521c7.jpg";